<!-- 帮助文档 -->
<template>
  <div class="help-doc">
    <v-head :bg="'transparent'"></v-head>
    <div
      class="container"
      style="
      min-width: 1200px;
      overflow:hidden;
      height: 100%;
      display: flex;
      flex-direction: column;"
    >
      <!-- banner -->
      <div class="help-banner">
        <div class="help-banner-img" :style="'background-image:url(' + img + ')'">
          <div class="help-banner-zz"></div>
        </div>
        <div class="help-bannerMsg">
          <div class="bannerMsg-message-title">政策新闻库</div>
          <div class="bannerMsg-message-search">
            <el-input
              placeholder="请输入关键词搜索"
              v-model="searchModel"
              class="input-with-select"
              @keyup.enter.native="tipswords()"
            ></el-input>
            <i class="el-icon-search" @click="tipswords()"></i>
          </div>
        </div>
      </div>
      <!-- main -->
      <div class="help-main">
        <div class="help-main-bread">
          <span class="firstbread" @click="returnMod()">热点新闻摘要</span>
        </div>
        <div class="help-main-con">
          <!-- 常见问题 -->
          <div class="con-problem">
            <div class="con-problemEach" v-for="(item,index) of problemList" :key="index">
              <div class="problem-tit" @click="backDetails(item)" v-html="item.title"></div>
              <div class="problem-con" v-html="isTwoline(item.content)"></div>
            </div>
          </div>
        </div>
        <!-- 分页 -->
        <div class="con-pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageSize.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- footer -->
    <v-footer></v-footer>
  </div>
</template>
<script>
import vHead from '@/components/header/header.vue'
import vFooter from '@/components/footer/footer.vue'
import {
  Button,
  Input,
  Pagination
} from 'element-ui'
export default {
  data () {
    return {
      img: 'https://sponsorentpic.nauac.com/20200506/96a3ad7bc60941eb82a31b5fcc049e75.jpg', // 临时图片
      searchModel: '',
      detailsList: {
        title: '',
        date: '',
        content: '',
        urls: ''
      },
      wordsList: ['云服务器', '网站备案', '云通信', '短信', '云数据库'],
      // 常见问题列表数据（临时）
      problemList: [],
      // 分页参数
      pageSize: {
        page: 1,
        size: 20
      },
      pageTotal: 0
    }
  },
  watch: {
    searchModel (val) {
      if (val === '') {
        this.$route.params.searchModel = ''
        this.init()
      }
    }
  },
  components: {
    'v-head': vHead,
    'v-footer': vFooter,
    'el-button': Button,
    'el-input': Input,
    'el-pagination': Pagination
  },
  created () {
    this.init()
    // 移动端适配最小高度为浏览器高度
    this.$nextTick(() => {
      let containerDom = document.getElementsByClassName('container')[0]
      if (containerDom) {
        containerDom.style.minHeight = (document.documentElement.clientHeight - 100) + 'px'
      }
    })
  },
  methods: {
    // 列表缩略文字初始化
    isTwoline (val) {
      let valList = JSON.parse(val)
      let text = ''
      valList.forEach(element => {
        if (element.type === 2 || element.type === '2') {
          text += element.info.replace(/\n/g, '').replace(/\s*/g, '')
        } else if (element.type === 3 || element.type === '3') {
          text += '【图片】'
        }
      })
      if (text && text.length > 190) {
        return text.substring(0, 190) + '...'
      } else {
        return text
      }
    },
    // 初始化加载列表
    init (type) {
      if (type && type === 'search') {
        this.pageSize.page = 1
      }
      if (this.$route.params.searchModel) {
        this.searchModel = this.$route.params.searchModel
      }
      this.$http({
        method: 'post',
        url: '/document/list',
        params: {
          question: this.searchModel,
          page: this.pageSize.page,
          pagesize: this.pageSize.size
        }
      }).then(res => {
        this.problemList = res.rows
        this.pageTotal = res.records
      }).catch(error => {
        console.log(error)
        return false
      })
    },
    // 文字回车/n转换
    returnText (val) {
      let str1 = val.replace(/\n/g, '<br/>')
      return str1
    },
    // 关键词点击事件
    tipswords (word) {
      this.$route.params.searchModel = ''
      this.init('search')
    },
    // 返回常见问题列表事件
    returnMod () {
      this.searchModel = ''
      this.$route.params.searchModel = ''
      this.init()
    },
    // 点击标题进入详情点击事件
    backDetails (item) {
      // 请求帮助文档详情
      this.$router.push({
        path: '/help/help_details',
        query: {
          id: item.id
        }
      })
    },
    // 分页方法
    handleSizeChange (val) {
      this.pageSize.size = val
      this.init('search')
    },
    handleCurrentChange (val) {
      this.pageSize.page = val
      this.init()
    },
    toA (url) {
      window.open(url)
    }
  }
}
</script>
<style src='./help_native.scss' lang="scss"></style>
<style lang="scss" scoped>
.help-doc {
  width: 100%;
}
// banner
.help-banner {
  width: 100%;
  height: 450px;
  position: relative;
  .help-banner-img {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    .help-banner-zz {
      background-color: rgba(0, 0, 0, 0.6);
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
  .help-bannerMsg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-top: 0;
    box-sizing: border-box;
    .bannerMsg-message-title {
      font-size: 30px;
      color: #ffffff;
      padding: 25px 0;
    }
    .bannerMsg-message-search {
      position: relative;
      i {
        width: 40px;
        height: 100%;
        display: inline-block;
        font-size: 18px;
        color: #666666;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 0;
        top: 0;
        z-index: 2;
        cursor: pointer;
      }
    }
    .bannerMsg-message-tips {
      width: 620px;
      text-align: left;
      font-size: 16px;
      font-weight: 400;
      color: #ffffff;
      padding: 15px 0;
      .tips-words {
        margin: 0 5px;
        cursor: pointer;
      }
    }
  }
}
// main
.help-main {
  width: 100%;
  max-width: 1200px;
  margin: 50px auto;
  height: auto;
  flex: 1;
  .help-main-bread {
    font-size: 16px;
    color: #333333;
    text-align: left;
    font-weight: 700;
    padding: 25px 20px 35px 20px;
    line-height: 24px;
    box-sizing: border-box;
    span.firstbread {
      cursor: pointer;
    }
    span.firstbread:hover {
      color: #2178ec;
    }
  }
  .help-main-con {
    border: 1px solid #f5f2f2;
    // 常见问题展示样式
    .con-problem {
      padding: 15px 20px;
      box-sizing: border-box;
      .con-problemEach {
        padding: 20px 0 20px 0;
        border-bottom: 1px solid #f5f2f2;
        .problem-tit {
          font-size: 14px;
          font-weight: 700;
          text-align: left;
          padding: 10px 0 5px 0;
          box-sizing: border-box;
          color: #333333;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
        }
        .problem-tit:hover {
          color: #000000;
        }
        .problem-con {
          color: #666666;
          font-size: 12px;
          line-height: 22px;
          text-align: left;
          padding: 5px 0;
          // text-overflow: -o-ellipsis-lastline;
          // overflow: hidden;
          // text-overflow: ellipsis;
          // display: -webkit-box;
          // -webkit-line-clamp: 2;
          // -webkit-box-orient: vertical;
        }
      }
      .con-problemEach:last-child {
        border-bottom: 0;
      }
    }
    // 常见问题详情展示样式
    .con-details {
      padding: 40px;
      box-sizing: border-box;
      .details-tit {
        font-size: 20px;
        // font-weight: 700;
        text-align: center;
        padding: 10px 0;
        box-sizing: border-box;
        color: #333333;
        line-height: 32px;
      }
      .details-titsm {
        font-size: 12px;
        color: #333333;
        text-align: center;
        padding: 30px 0;
        border-bottom: 1px dashed #dedede;
      }
      .details-con {
        padding-top: 25px;
        .details-itemss {
          margin-bottom: 15px;
        }
      }
    }
  }
  .con-pagination {
    margin-top: 25px;
    text-align: right;
  }
}
.details-href {
  display: flex;
  align-items: flex-start;
  margin-top: 60px;
  span {
    line-height: 20px;
    width: 90px;
    font-size: 14px;
  }
  ul {
    width: 100%;
    list-style: none;
    li {
      line-height: 20px;
      list-style: none;
      margin-bottom: 8px;
      a {
        font-size: 14px;
      }
    }
  }
}
</style>
<style lang="css">
.details-con p a {
  display: inline-block;
  text-decoration: none;
  color: #666666;
  line-height: 22px;
  text-align: left;
}
.details-con p a u,
.details-con p a u span {
  display: inline-block !important;
  text-decoration: none !important;
  color: #666666 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/help/help.vue